import { render, staticRenderFns } from "./ViewAsTeacherFooter.vue?vue&type=template&id=5483ee2c&scoped=true&"
import script from "./ViewAsTeacherFooter.vue?vue&type=script&lang=ts&"
export * from "./ViewAsTeacherFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ViewAsTeacherFooter.vue?vue&type=style&index=0&id=5483ee2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483ee2c",
  null
  
)

export default component.exports